import * as commonStyles from "styles/Common.module.scss";

import CustomLoader from "components/common/CustomLoader/CustomLoader";
import DlightKenyaDataForm from "./DlightKenyaDataForm";
import NoDataFound from "components/common/NoDataFound/NoDataFound";
import { getErrorMessage } from "common/utils/errorUtils";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getDlightKenyaDataDetail } from "common/API/dlightKenyaAPIs";

import { PAGE_IDENTIFIERS } from "common/constants";
import { clearKenyaFilters } from "common/utils/utils";
import { useAutoClearFilter } from "common/hooks/useAutoClearFitlers";

const DlightKenyaDataDetail = () => {
  const { recordId } = useParams();

  /* To automatically clear dlight-kenya filters for a given page identifier. */
  const pageIdentifier = PAGE_IDENTIFIERS.DLIGHT_KENYA;
  useAutoClearFilter(pageIdentifier, clearKenyaFilters);

  const {
    data: response,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery(["dlight-kenya-data-detail", recordId], () =>
    getDlightKenyaDataDetail(recordId)
  );

  if (isLoading) {
    return (
      <CustomLoader
        containerClasses={commonStyles.Full_Height_Flex_Container}
      />
    );
  }

  if (error?.response?.status === 404) {
    return (
      <NoDataFound
        {...{
          title: `No dlight kenya record with ID ${recordId} found`,
          wrapperClasses: commonStyles.Full_Height_Flex_Container,
        }}
      />
    );
  }

  if (isError) {
    toast.error(
      getErrorMessage(
        error,
        `Cannot fetch requested record with ID ${recordId}`
      )
    );
  }

  return (
    <main className="px-1 py-5">
      <DlightKenyaDataForm
        {...{ record: response?.data?.payload, refetchRecord: refetch }}
      />
    </main>
  );
};

export default DlightKenyaDataDetail;
